import { isLightTheme } from '@/theme/semanticTokens';
import { r } from '@/theme/tokens/radii';
import { Badge, Box, Text } from '@/ui/primitives';
import { alpha, darken } from '@/ui/primitives/colorUtils';
import type { ReactElement } from 'react';

export const SidebarCollapsedNotificationIcon = ({
  icon,
}: {
  icon: ReactElement;
}): ReactElement => (
  <Badge
    color="error"
    max={99}
    overlap="circular"
    sx={(theme) => ({
      '& .MuiBadge-badge': {
        width: theme.app.iconSizes.notificationDot,
        minWidth: theme.app.iconSizes.notificationDot,
        height: theme.app.iconSizes.notificationDot,
        borderRadius: '50%',
        padding: 0,
        transform: 'scale(1) translate(72%, -72%)',
        transformOrigin: '100% 0%',
      },
    })}
    variant="dot"
  >
    {icon}
  </Badge>
);

export const SidebarNotificationBadge = ({
  itemLabel,
  notificationLabel,
}: {
  itemLabel: string;
  notificationLabel: string;
}): ReactElement => (
  <Box
    aria-label={`${notificationLabel} new ${itemLabel} items`}
    sx={(theme) => ({
      width: 22,
      height: 22,
      borderRadius: r('pill'),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      backgroundColor: isLightTheme(theme)
        ? alpha(theme.app.colors.danger, 0.3)
        : theme.app.colors.danger,
      border: isLightTheme(theme) ? `1px solid ${alpha(theme.app.colors.danger, 0.42)}` : 'none',
      color: isLightTheme(theme) ? darken(theme.app.colors.danger, 0.48) : '#000',
    })}
  >
    <Text
      role="body"
      component="span"
      color="inherit"
      sx={{
        fontSize: notificationLabel.length > 2 ? '9px' : '11px',
        fontWeight: 700,
        lineHeight: 1,
      }}
    >
      {notificationLabel}
    </Text>
  </Box>
);
